module.exports = __webpack_public_path__ + "assets/img/thumb-The-Strand-Coollangatta-Video.d98a2129.jpg";